import { Injectable } from '@angular/core';
import { Search } from '@df/search/search.interfaces';
import { SearchResult } from '@df/search/search-result';

@Injectable({
    providedIn: 'root'
})
export class SearchResultFactoryService {
    create(term: string, data: Search.IResult, options: Search.ISearchResultOptions) {
        return new SearchResult(term, data, options);
    }
}
